import { useSubscriptionsInfo } from 'constants/subscriptions';

import {
  IMappedSubscriptionItem,
  ISubscriptionItem,
  IUserSubscriptionResponse,
  SUBSCRIPTION_COLOR,
  SUBSCRIPTION_PLAN,
  SUBSCRIPTION_RECURRENT,
  SUBSCRIPTION_STATUS,
} from 'interfaces/subscriptions';

export const useMapUserSubscriptions = (
  userSubscription: IUserSubscriptionResponse | null,
): IMappedSubscriptionItem[] => {
  const subscriptions = useSubscriptionsInfo();
  if (!userSubscription) {
    return [];
  }
  const { currentSubscription, nextSubscription } = userSubscription;
  const isCurrentSubscriptionStandard = currentSubscription.subscriptionPlan === SUBSCRIPTION_PLAN.STANDARD;
  const isCurrentSubscriptionActive = currentSubscription.status === SUBSCRIPTION_STATUS.ACTIVE;
  const isCurrentSubscriptionFree = currentSubscription.subscriptionPlan === SUBSCRIPTION_PLAN.FREE;
  const isHasStandardSubscription = currentSubscription.subscriptionPlan === SUBSCRIPTION_PLAN.STANDARD;

  const subscriptionData = subscriptions.map((subscriptionItem: ISubscriptionItem): IMappedSubscriptionItem => {
    const isCurrentPlan = subscriptionItem.tariff === currentSubscription.subscriptionPlan;
    const isNextPlan = subscriptionItem.tariff === nextSubscription.subscriptionPlan;
    const isSubscriptionItemLight = subscriptionItem.tariff === SUBSCRIPTION_PLAN.LIGHT;
    const isSecondaryColor =
      ((isCurrentPlan && !isCurrentSubscriptionFree) || (isCurrentSubscriptionFree && isSubscriptionItemLight)) &&
      !(isCurrentPlan && isCurrentSubscriptionStandard && isCurrentSubscriptionActive);
    const isHasStandardOnLightTariff = isSubscriptionItemLight && isHasStandardSubscription;

    return {
      ...subscriptionItem,
      isCurrentPlan,
      isNextPlan,
      nextSubscriptionPlan: nextSubscription.subscriptionPlan,
      nextSubscriptionRecurrent: nextSubscription.recurrent,
      subscriptionStatus:
        subscriptionItem.tariff === currentSubscription?.subscriptionPlan ? currentSubscription.status : null,
      currentSubscriptionStatus: currentSubscription.status,
      subscriptionRecurrent: currentSubscription?.recurrent ?? SUBSCRIPTION_RECURRENT.ANNUALLY,
      endDate: currentSubscription?.endDate ?? 0,
      color: isSecondaryColor ? SUBSCRIPTION_COLOR.SECONDARY : SUBSCRIPTION_COLOR.PRIMARY,
      isHasStandardOnLightTariff,
    };
  });

  const dataToShowIndex = subscriptionData.findIndex(
    ({ isNextPlan, isCurrentPlan, currentSubscriptionStatus }): boolean =>
      currentSubscriptionStatus === SUBSCRIPTION_STATUS.ACTIVE ? isCurrentPlan : isNextPlan,
  );

  if (dataToShowIndex === -1) {
    return subscriptionData;
  }

  return subscriptionData.splice(dataToShowIndex);
};
